import action from '../../../abstract/action.js';

export default action({
  label: 'Edytuj',
  icon: 'EditIcon',
  main: () => false,
  handle: async ({ $router, item }) => await $router.push({ name: 'system-roles-edit', params: { id: item.id } }),
});
